export class Layout {
  style: any = {};

  class: string[] = [];
}
